import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 6",
  width: "24",
  height: "24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h9v3H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#d52b1e",
      d: "M0 3h9v3H0z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0039a6",
      d: "M0 2h9v2H0z"
    }, null, -1)
  ]))]))
}